export default {
  jp: {
    title: {
      logout: 'ログアウト'
    }
  },
  en: {
    title: {
      logout: 'Logout'
    }
  }

}
